// Navigation routes for the application

export const routes = {
  // Root
  landing: '/',
  onboarding: '/onboarding',

  // Auth
  connect: '/connect',
  login: '/login',
  signUp: '/signup',
  userDetails: '/user-details',
  signUpWithMobile: '/signup-mobile',
  otpCode: '/otp',
  otpVerification: '/otp-verification',
  createPassword: '/create-password',
  successfulPassword: '/password-success',
  faceId: '/face-id',
  fingerprint: '/fingerprint',
  selectCountry: '/select-country',
  selectReason: '/select-reason',
  createPin: '/create-pin',
  uploadDocument: '/upload-document',
  uploadPhotoId: '/upload-photo-id',
  selfieWithId: '/selfie-id',
  verifySuccess: '/verify-success',

  // Main tabs
  home: '/home',
  market: '/market',
  buckets: '/buckets',
  bucketDetail: '/buckets/:bucketName',
  portfolio: '/portfolio',
  profile: '/profile',
  wallet: '/wallet',
  copilot: '/copilot',
  companyDetail: '/company/:companyName',
  sectorDetail: '/sectors/:sectorName',
  marketMonitor: '/market-monitor',

  // Expert
  expertSearch: '/experts',
  expertProfile: '/expert/:id',
  expertBooking: '/expert/:id/book',
  expertBookingConfirmation: '/expert/:id/book/confirm',
  allBookings: '/bookings',
  chatScreen: '/chat/:bookingId',
  callScreen: '/call/:bookingId',
  rateExpert: '/rate/:bookingId',

  // Expert Settings (for experts only)
  expertSettings: '/expert/settings',
  expertAvailability: '/expert/settings/availability',
  expertRates: '/expert/settings/rates',
  expertSebiCredentials: '/expert/settings/sebi',
  expertWallet: '/expert/settings/wallet',
  expertSpecializations: '/expert/settings/specializations',
  expertCalls: '/expert/settings/calls',
  expertNewCall: '/expert/settings/calls/new',

  // Market - Crypto
  cryptoScreen: '/market/crypto',
  searchCrypto: '/market/crypto/search',
  cryptoDetails: '/market/crypto/:id',
  portfolioOfCrypto: '/market/crypto/portfolio',
  buyCrypto: '/market/crypto/buy/:id',
  sellCrypto: '/market/crypto/sell/:id',
  exchangeCrypto: '/market/crypto/exchange',
  cryptoHistory: '/market/crypto/history',

  // Market - Stock
  stocksScreen: '/market/stocks',
  marketSectors: '/market/stocks/sectors',
  searchStocks: '/market/stocks/search',
  detailsStock: '/market/stocks/:id',
  stockPortfolio: '/market/stocks/portfolio',
  buyStock: '/market/stocks/buy/:id',
  sellStock: '/market/stocks/sell/:id',
  exchangeStock: '/market/stocks/exchange',
  stockHistory: '/market/stocks/history',
  stockFutures: '/market/stocks/futures',

  // Market - NFTs
  nftsScreen: '/market/nfts',
  placeBid: '/market/nfts/place-bid/:id',
  collectionItem: '/market/nfts/collection/:id',
  activityNFts: '/market/nfts/activity',
  collectionItemDetails: '/market/nfts/collection/:collectionId/:itemId',
  createdByCollection: '/market/nfts/created-by/:id',

  // Market - Gold
  goldScreen: '/market/gold',
  goldDetails: '/market/gold/details',
  autoInvestGold: '/market/gold/auto-invest',
  goldLoan: '/market/gold/loan',
  redeemGold: '/market/gold/redeem',
  buyGold: '/market/gold/buy',
  goldHistory: '/market/gold/history',
  successfulInvest: '/market/gold/success',

  // Subscription
  pricing: '/pricing',

  // Admin
  adminDashboard: '/admin',
  adminUsers: '/admin/users',
  adminUserDetail: '/admin/users/:id',
  adminPayments: '/admin/payments',
  adminBookings: '/admin/bookings',
  adminExperts: '/admin/experts',
  adminEmail: '/admin/email',
  adminBlacklist: '/admin/blacklist',
  adminSupport: '/admin/support',
  adminAuditLog: '/admin/audit-log',
  adminBuckets: '/admin/buckets',
  adminBucketDetail: '/admin/buckets/:bucketName',
  adminCompanyInsights: '/admin/companies',
  adminLLMConfig: '/admin/llm-config',
  adminEmbeddingConfig: '/admin/embedding-config',

  // Home
  notification: '/notifications',
  notificationDetails: '/notifications/:id',
  watchListHomeCard: '/watchlist',
  topGainers: '/top-gainers',
  stockScreen: '/stocks',

  // Portfolio
  portfolioHistory: '/portfolio/history',
  historyTransactionDetails: '/portfolio/history/:id',
  historyReport: '/portfolio/report',

  // Profile
  personalDetails: '/profile/personal-details',
  bankAccount: '/profile/bank-account',
  bankAccountDetails: '/profile/bank-account/:id',
  addBankAccount: '/profile/bank-account/add',
  selectLanguage: '/profile/language',
  pushNotification: '/profile/notifications',
  helpCenter: '/profile/help',
  faqScreen: '/profile/faq',
  privacyPolicies: '/profile/privacy',
  termsAndCondition: '/profile/terms',
  refundAndCancellationPolicies: '/profile/refund',
  referralCode: '/profile/referral',
  aboutApp: '/profile/about',
  supportTicket: '/support/ticket',

  // Wallet
  myWalletDeposit: '/wallet/deposit',
  selectBankAccountDeposit: '/wallet/deposit/select-bank',
  depositPreview: '/wallet/deposit/preview',
  depositSuccessful: '/wallet/deposit/success',
  myWalletWithdraw: '/wallet/withdraw',
  selectBankAccountWithdraw: '/wallet/withdraw/select-bank',
  withdrawSuccessful: '/wallet/withdraw/success',
  sendWallet: '/wallet/send',
  transferBalance: '/wallet/transfer',
  transferPreview: '/wallet/transfer/preview',
};

export default routes;
